import { render, staticRenderFns } from "./OrderServicesDetails.vue?vue&type=template&id=a4d4d96e"
import script from "./OrderServicesDetails.vue?vue&type=script&lang=js"
export * from "./OrderServicesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports